import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import { Automata } from '../../components/examples/';
export const _frontmatter = {
  "Title": "1D automata"
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "1d-automata"
    }}>{`1D Automata`}</h1>
    <Automata mdxType="Automata" />
    <p><a parentName="p" {...{
        "href": "https://mathworld.wolfram.com/ElementaryCellularAutomaton.html"
      }}>{`1D cellular automata`}</a>{` are among the simplest of automata.
Each line consists of a series of cells which are either set (colored) or not.`}</p>
    <p>{`At each tick, we use a rule to determine whether cells on the next line will be set.
For each new cell, we consider the three cells above. There are 8 possible combinations - each of these cells can be set or not (so 2x2x2).
For each of these combinations, the rule determines whether the cell should be set or not. So we have 2`}<sup>{`8`}</sup>{` rules, or 256.`}</p>
    <p>{`You can select a rule by adjusting the slider, or by clicking on each of the bits.`}</p>
    <p>{`This simulation is an interesting example of `}<a parentName="p" {...{
        "href": "/react-sim/controls/custom-controls"
      }}>{`custom control components`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      